export default {
  header: {
    home: 'ホーム',
    about: '会社概要',
    technology: '技術紹介',
    products: '製品紹介',
    services: 'サービス',
    contacts: 'お問い合わせ',
    rawMaterial: '原材料カスタマイズ',
    productCustomization: '製品カスタマイズ',
    importExport: '輸出入'
  },
  home: {
    coreBusiness: '事業内容',
    platform: '新規ドラッグデリバリープラットフォーム',
    oneStopPlatform: 'ワンストップ産業チェーンサービスプラットフォーム',
    formulation: '革新的製剤',
    dosageForm: '剤形',
    dosageForms: {
      oralFilms: '口腔内崩壊フィルム',
      transdermal: '経皮吸収パッチ',
      granule: '口腔内崩壊顆粒'
    },
    application: '用途',
    applicationText: '小児、高齢者、嚥下困難な患者、ペット',
    productStrategy: '製品戦略デザイン',
    productInfo: '製品情報データベース & プロジェクト立ち上げガイダンス',
    productRegistration: '製品登録サービス',
    salesMarket: '販売 & 市場開発',
    supplyDistribution: '原材料供給 & 製品流通 & カスタマイズサービス'
  },
  about: {
    companyProfile: '会社概要',
    location: 'セイカファーマ株式会社 (大阪)',
    businessScopes: '事業範囲:',
    scope1: '新規生産サービス開発',
    scope2: 'FDA登録サービス',
    scope3: '化粧品、健康食品、医薬品、添加剤の海外事業',
    scope4: 'ペットフード、ペット用品、飼料添加物、ペットケアの小売および卸売',
    missionVision: '経営理念 (Mission & Vision)'
  },
  footer: {
    exploration: '今日の探求',
    innovation: '永遠の革新',
    pioneering: '開拓',
    exploring: '探求',
    innovating: '革新',
    surpassing: '超越',
    subscribeNow: '今すぐ登録',
    subscribe: '登録',
    contacts: 'お問い合わせ',
    email: 'メール：',
    copyright: 'Seikaiyaku.com | プライバシーポリシー© 2025 全著作権所有',
    copyrightMb: 'Copyright©2018-2025 Seikaiyaku.com All Rights Reserved.'
  },
  technology: {
    ddsTitle: 'DDSと技術革新',
    oralFilms: '口腔内崩壊フィルム（OTFs）',
    oralGranules: '口腔内崩壊顆粒（ODGs）',
    transdermalPatches: '経皮吸収パッチ',
    technicalSupport: '技術サポート',
    productDesign: '製品設計と技術支援。',
    comprehensiveSolutions: '包括的な産業ソリューション。',
    innovativePractice: '革新的な実践',
    effectiveFormula: '医薬品、ペット用医薬品における効果的な処方製品、',
    petNutrition: 'ペット栄養、健康食品。',
    enhancingConvenience: '利便性と吸収効率の向上。',
    purpleBanner: '医薬品、ペット用医薬品、ペット栄養、健康食品に関連。'
  },
  contacts: {
    title: 'セイカファーマ お問い合わせ',
    contactsUs: 'お問い合わせ',
    registeredOffice: 'オフィス',
    addressLabel: '住所：',
    address: '〒546-0002 大阪府大阪市東住吉区杭全1-17-17 3F',
    emailLabel: 'メール：',
    sendMessage: 'メッセージを送る',
    name: '名前',
    email: 'メール',
    subject: '件名',
    yourMessage: 'メッセージ',
    send: '送信'
  },
  products: {
    title1: '還元型コエンザイムQ10とは？',
    subtitle1: '還元型コエンザイムQ10カプセルの力で若返る - 優れた吸収性、最大の効果！',
    body1: 'ユビキノール（還元型コエンザイムQ10）は体内に存在する物質であり、体内の細胞エネルギー（ATP）の自然な生成に必要な栄養素です。',
    body2: 'ユビキノールは細胞に強力な抗酸化保護を提供します。',
    body3: 'ユビキノールは体内の主要な（99%以上）活性型CoQ10です。',
    featuresTitle: '製品の特徴',
    feature1Title: '還元型コエンザイムQ10',
    feature1Text: '変換不要、急速吸収、高い生体利用効率、酸化型コエンザイムQ10の8倍の効率',
    feature2Title: 'プレミアム成分',
    feature2Text: '日本最高品質の還元型コエンザイムQ10、優れた製品性能',
    feature3Title: '科学的根拠による裏付け',
    feature3Text: '7つの主要な科学研究が有効性を支持',
    detailsTitle: '製品詳細',
    distributionTitle: '販売・購入',
    officialStore: 'セイカファーマ公式ストア',
    address: '住所：〒531-0073 大阪府大阪市東住吉区杭全1-17-17 3F',
    contact: 'お問い合わせ：',
    ingredients: '成分',
    ingredientsTitle: '成分',
    ingredientsText1: '還元型コエンザイムQ10',
    ingredientsText2: 'ビタミンE',
    ingredientsText3: 'レシチン',
    ingredientsText4: 'ミツロウ',
    ingredientsTextMobile2: 'ベニバナ油',
    ingredientsTextMobile3: 'スイートアーモンドオイル',
    specification: '仕様',
    specificationText1: 'カプセル重量：345mg',
    specificationText2: '60カプセル/ボトル',
    specificationText3: null,
    suggestedUse: '使用方法',
    suggestedUseText1: '健康維持のために',
    suggestedUseText2: '1日1〜2カプセルを目安に水と一緒にお召し上がりください',
    suggestedUseText3: null,
    shelfLife: '賞味期限',
    shelfLifeText1: '36ヶ月',
    shelfLifeText2: null,
    shelfLifeText3: null,
    targetUsersTitle: '対象ユーザー',
    targetUsersText1: '疲れを感じている方',
    targetUsersText2: '中高年の方',
    targetUsersText3: '心血管疾患のある方',
    targetUsersText4: '慢性疾患のある方',
    benefitsTitle: '利点',
    benefitsText1: '心臓の健康を増進',
    benefitsText2: '老化防止',
    benefitsText3: '日々の活力を向上',
    benefitsText4: '身体の必須物質合成能力を改善',
    packageTitle: 'パッケージと用量',
    packageText1: '30カプセル/ボトル',
    packageText2: 'ソフトカプセル',
    packageText3: '1日1カプセル'
  },
  platform: {
    title: 'エンドツーエンドの統合生産ソリューション',
    upstreamLabel: '上流:',
    upstreamValue: '原材料',
    upstream1: '登録戦略指導',
    upstream2: 'コンプライアンス・コンサルティング',
    upstream3: 'チャネル・マッチング',
    midstreamLabel: '中流:',
    midstreamValue: '製品の研究開発と生産',
    midstream1: '製品設計サポート',
    midstream2: '革新的な製剤開発',
    downstreamLabel: '下流:',
    downstreamValue: '販売とマーケティング',
    downstream1: '販売と市場開拓'
  },
  services: {
    rawMaterial: '原材料のカスタマイズ',
    productCustomization: '製品のカスタマイズ',
    importExport: '輸出入',
    learnMore: '詳細はこちら >'
  },
  flow: {
    title: 'ドア・ツー・ドアのカスタマイズ生産プロセス',
    titleMobile1: 'ドア・ツー・ドアのカスタマイズ',
    titleMobile2: '生産プロセス',
    manufactureCoordination: '製造調整',
    oa: 'OA',
    manufacturing: '製造',
    packaging: '包装',
    shipping: '出荷',
    seikaPharma: 'セイカファルマ',
    tradeCompliance: '輸出入規制に準拠した国際貿易',
    tradeComplianceMobile1: 'コンプライアンスを遵守した国際貿易',
    tradeComplianceMobile2: '（輸出入規制）',
    customer: '顧客',
    exportCertificate: '輸出検疫証明書、輸入許可証',
    specialPackaging: '顧客指定場所への特別梱包配送',
    back: '戻る'
  },
  business: {
    title: '医薬品の輸出入',
    titleMobile1: '医薬品',
    titleMobile2: '輸出入',
    marketResearch: '市場調査と分析',
    regulations: '規制とコンプライアンス',
    productRegistration: '製品登録',
    logistics: '物流とサプライチェーン管理',
    description: '私たちのチームは、市場の拡大と革新的な販売戦略の構築に取り組んでいます。パートナーと緊密に連携し、医薬品の輸出入の取り組みを強化しています。常に新しいパートナーシップを模索し、使命の達成を目指しています。',
    learnMorePartners: 'パートナーについて知る'
  },
  popularize: {
    title: '製品プロモーション戦略',
    subtitle: '統合オムニチャネル小売モデルの構築',
    offlinePromotion: 'オフライン販売促進',
    offlineP1: '国内完全カバーのオフライン販売チーム',
    offlineP2: '多面的なオフライン販促活動',
    offlineP3: '体系的なオフライン販売トレーニングシステム',
    onlinePlatform: 'オンライン運営プラットフォーム',
    onlineP1: 'オンライン専門Eコマース運営チーム',
    onlineP2: 'ワンストップデジタルマーケティング体験',
    onlineP3: 'ニューメディアマルチプラットフォーム協力チャネル',
    offlineChannels: 'オフラインチャネル',
    retailPharmacies: '小売薬局',
    publicHospitals: '公立病院',
    medicalCosmetologies: '美容医療',
    beautySalon: '美容サロン',
    onlineChannels: 'オンラインチャネル',
    ecommerceChannels: 'Eコマースチャネル',
    livestreaming: 'ライブストリーミング運営チーム'
  },
  material: {
    title: 'カスタマイズされた原材料と供給調整サービス',
    titleMobile1: 'カスタマイズされた原材料と',
    titleMobile2: '供給調整サービス',
    supplyServices: '供給サービス',
    supplyDescription: '原材料および中間体の調達、輸出入サービスを促進します。',
    salesAgencyServices: '販売代理店サービス',
    salesAgencyDescription: '原材料の販売代理サービスを提供します。',
    apiServices: 'APIおよび中間体供給サービス',
    apiDescription: '強固なパートナーシップとR&D製造能力を持ち、クライアントのニーズに合わせたカスタマイズサービスを提供します。'
  },
  expansion: {
    title: 'グローバル市場拡大',
    marketAnalysis: '市場分析と戦略',
    globalCompliance: 'グローバルコンプライアンスと登録',
    buildingSalesChannels: '販売チャネルの構築',
    elevatingBrand: 'ブランドプレゼンスの向上',
    buildingAlliances: '戦略的提携の構築',
    monitoringOptimizing: 'モニタリングと最適化'
  },
  coq10: {
    auth: {
      accessDenied: 'アクセス拒否',
      providePassword: '正しいアクセスパスワードを入力してください',
      enterPassword: 'アクセスパスワードを入力',
      confirm: '確認',
      incorrectPassword: 'パスワードが間違っています。もう一度お試しください！',
      verificationSuccess: '認証に成功しました！'
    },
    hero: {
      brandName: 'PHARMOPTIMA',
      productName: '還元型コエンザイムQ10カプセル',
      capacity: '100mg',
      subtitle: '優れた吸収性、最大の効果、活力を取り戻す！',
      reducedForm: '還元型',
      coq10: 'CoQ10'
    },
    info: {
      whatIsTitle: '還元型コエンザイムQ10とは？',
      whatIsText1: 'コエンザイムQ10（CoQ10）は体内で自然に生成される物質であり、細胞エネルギー（ATP）の生成に不可欠であり、強力な抗酸化物質でもあります。',
      whatIsText2: '還元型コエンザイムQ10は、体内のCoQ10の活性型（>95%）です（Wade et al., JAGS 55:1141, 2007）。エネルギー供給、抗酸化保護、フリーラジカルの除去を行い、心血管系および神経系に顕著な効果をもたらします。高い生体利用効率を持ち、直接吸収されます。加齢とともに体内のCoQ10レベルは低下し、還元型CoQ10レベルは著しく低下します。',
      advantagesTitle: '製品の利点',
      adv1Title: '還元型コエンザイムQ10',
      adv1Text: '変換不要、急速吸収、高い生体利用効率、酸化型の8倍の吸収率。',
      adv2Title: '高品質な成分',
      adv2Text: '日本最高品質の還元型コエンザイムQ10原料を使用し、優れた製品性能を実現。',
      adv3Title: '科学的根拠による裏付け',
      adv3Text: '7つの主要な科学論文がその有効性を支持しています。'
    },
    productInfo: {
      title: '製品情報',
      targetUsersTitle: '対象ユーザー',
      targetUsers1: '夜更かしや疲れやすい方',
      targetUsers2: '中高年の方',
      targetUsers3: '心血管疾患のある方',
      targetUsers4: '慢性疾患のある方',
      scopeTitle: '適用範囲',
      scope1: '心筋細胞を保護し、心臓の健康を増進',
      scope2: '老化防止',
      scope3: '日々の活力を向上',
      scope4: '身体の必須物質合成能力を改善',
      ingredientsTitle: '成分',
      ingredient1: '還元型コエンザイムQ10',
      ingredient2: 'ベニバナ油',
      ingredient3: 'グリセリン脂肪酸エステル',
      ingredient4: 'ミツロウ',
      specTitle: '仕様、剤形、使用方法',
      spec1: '30カプセル/ボトル',
      spec2: 'ソフトカプセル',
      spec3: '1日1粒',
      marketTitle: '販売国/地域および分類、販売チャネル',
      market1: '日本/栄養補助食品',
      market2: '越境EC'
    },
    purchase: {
      buyNow: '今すぐ購入',
      scanCode: 'QRコードをスキャンして購入',
      contactUs: 'お問い合わせ'
    }
  },
  registration: {
    title: '薬事申請と製品登録',
    titleMobile1: '薬事申請と製品',
    titleMobile2: '登録',
    roadMapTitle: '登録サービスロードマップ',
    marketEntryStrategy: '市場参入戦略',
    registrationServices: '中国における登録サービス',
    registrationServicesExplain: '医薬品、原薬、新食品原料、化粧品を含む',
    endToEndSupport: '一貫したサポート',
    proposalCreating: '提案書の作成',
    technicalSupport: '技術サポート',
    documentReview: '書類レビュー',
    documentDrafting: '書類作成',
    governmentCommunication: '政府機関とのコミュニケーション',
    processTracking: 'プロセスの追跡'
  },
  meta: {
    home: 'セイカファーマ',
    about: '会社概要 | セイカファーマ',
    technology: '技術紹介 | セイカファーマ',
    products: '製品紹介 | セイカファーマ',
    contacts: 'お問い合わせ | セイカファーマ',
    platform: 'プラットフォーム | セイカファーマ',
    services: 'サービス | セイカファーマ',
    popularize: 'プロモーション | セイカファーマ',
    expansion: '海外展開 | セイカファーマ',
    material: '原材料 | セイカファーマ',
    flow: '生産プロセス | セイカファーマ',
    business: '輸出入事業 | セイカファーマ',
    registration: '薬事申請・登録 | PHARM OPTIMA',
    coq10: '還元型CoQ10 | PHARMOPTIMA'
  }
}
